module.exports = __webpack_public_path__ + "static/videoES_1-fa0e2ca81a0083e502ac9132535ee847.mp4";